import {
  requiredString,
  requiredSelect,
  requiredPositiveNumber,
  optionalFile,
  createResourceSchema
} from './common'

export const printAssetSchema = createResourceSchema({
  name: requiredString('Name'),
  size: requiredSelect('Size'),
  orientation: requiredSelect('Orientation'),
  asset: optionalFile,
  qr_x: requiredPositiveNumber('QR X position'),
  qr_y: requiredPositiveNumber('QR Y position'),
  qr_width: requiredPositiveNumber('QR width')
})
